import { useQuery } from "react-query";
import { UIViewEnum } from "../../common/enums/UIViewEnum";
import { IeLynxObject } from "../../common/models/eLynxObject";
import { INavigationItem } from "../../services/navigation-data-service/Models";
import NavigationDataService, { RelatedObjectOptions } from "../../services/navigation-data-service/NavigationDataService";
import { RestError } from "../../services/rest-service/RestService";
import { BaseUseQueryParameters } from "../BaseUseQueryParameters";
import { keys } from "./Keys";
import { useCallback } from "react";
import { contains } from "../../common/utilities/Contains";


export type UseAvailableObjectsQueryParameters = {
    customerID: number,
    contextGroupID: number,
    contextObject: IeLynxObject,
    viewID: UIViewEnum,
    options: RelatedObjectOptions,
    filterText?: string,
    offline: boolean
} & BaseUseQueryParameters<INavigationItem[]>

export function useAvailableObjects({
    customerID,
    contextGroupID,
    contextObject,
    viewID,
    options,
    filterText,
    offline
}: UseAvailableObjectsQueryParameters) {
    return useQuery<INavigationItem[] | undefined, RestError>(
        keys.availableObjects(
            customerID,
            contextGroupID,
            contextObject,
            viewID,
            options,
            offline
        ),
        ({ signal }) => {
            if (customerID) {
                return NavigationDataService.getRelatedObjects(
                    customerID,
                    contextGroupID,
                    contextObject,
                    viewID,
                    options,
                    offline,
                    signal
                );
            }
        },
        {
            select: useCallback(
                (data: INavigationItem[] | undefined) => onSelect(data, filterText ?? ""),
                [filterText]
            )
        }
    );
}

function onSelect(
    data: INavigationItem[] | undefined,
    filterText: string,
): INavigationItem[] {
    const filteredData = data
        ? data
            .filter((item) => {
                return contains(item.title, filterText);
            })
            .sort((a, b) => {
                return a.title.localeCompare(b.title);
            })
        : [];

    return filteredData;
}